import React from "react";
import "./Datenschutz.css";

const PrivacyPolicy = () => {
  return (
    <div className="container py-5 datenschutz">
      <h1 className="mb-4 text-center">Datenschutzerklärung</h1>

      <div className="mb-5">
        <h4>1. Verantwortlicher</h4>
        <p>
          VfB Johannesberg 1984 e.V.<br />
          1. Vorsitzender: Karsten Seilius<br />
          Douglasienweg 2<br />
          36251 Bad Hersfeld<br />
          Tel: <a href="tel:01717924528">0171-7924528</a>
        </p>
      </div>

      <div className="mb-5">
        <h4>2. Hosting</h4>
        <p>
          Unsere Website wird bei der STRATO AG (Otto-Ostrowski-Straße 7, 10249 Berlin)
          gehostet. Beim Aufruf der Website werden durch STRATO automatisch Informationen
          (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs) in sogenannten Server-Logfiles
          gespeichert. Diese Daten dienen der Sicherstellung eines störungsfreien Betriebs
          und werden nicht personenbezogen ausgewertet.
        </p>
      </div>

      <div className="mb-5">
        <h4>3. Kontaktformular</h4>
        <p>
          Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben
          aus dem Formular inklusive der von Ihnen dort angegebenen Kontaktdaten zur
          Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
        </p>
        <p>
          Die Verarbeitung der Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO,
          sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur
          Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen
          beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven
          Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO).
        </p>
        <p>
          Ihre Daten werden ohne Ihre Einwilligung nicht an Dritte weitergegeben.
        </p>
      </div>

      <div className="mb-5">
        <h4>4. Cookies</h4>
        <p>
          Unsere Website verwendet keine Cookies.
        </p>
      </div>

      <div className="mb-5">
        <h4>5. Externe Inhalte</h4>
        <p>
          Wir binden keine externen Inhalte wie Google Maps, YouTube oder Social Media Plugins ein.
        </p>
      </div>

      <div className="mb-5">
        <h4>6. Ihre Rechte</h4>
        <p>Sie haben das Recht auf:</p>
        <ul>
          <li>Auskunft über Ihre bei uns gespeicherten Daten (Art. 15 DSGVO)</li>
          <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
          <li>Löschung Ihrer Daten (Art. 17 DSGVO)</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
        </ul>
        <p>
          Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen
          die DSGVO verstößt, haben Sie das Recht auf Beschwerde bei der zuständigen
          Aufsichtsbehörde.
        </p>
      </div>

      <div className="text-muted text-center">
        Stand: {new Date().toLocaleDateString("de-DE")}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
